<template>

  <div>

    <data-table
      ref="progress-table"
      table-ref="progesstable"

      :title="permitLabel + ' Report'"
      icon="fa fa-file"

      url="/view/actions/prg"
      :fields="fields"

      sort-field="siteName"
      detail-component="progress-detail-row">
  </data-table>

</div>
</template>

<script>
import Vue from 'vue'

import DateMixins from '@/mixins/DateMixins'
import NumberMixins from '@/mixins/NumberMixins'

import ProgressDetail from '@/components/progress/ProgressDetail'

import {settings} from '@/components/Data'

Vue.component('progress-detail-row', ProgressDetail)

export default {
  mixins: [DateMixins, NumberMixins],

  data () {
    return {
      permitLabel: settings.permitLabel,
      fields: [
        {
          name: '__sequence',
          title: '#',
          sortField: 'id'
        },
        {
          name: 'status',
          title: 'Status',
          sortField: 'status'
        },
        {
          name: 'siteId',
          title: 'Site ID',
          sortField: 'siteId',
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down'
        },
        {
          name: 'siteName',
          title: 'Site Name',
          sortField: 'siteName'
        },
        {
          name: 'submitted_at',
          title: 'Submitted',
          sortField: 'submitted_at',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down',
          callback: this.formatDate
        },
        {
          name: 'completed_at',
          title: 'Completed',
          sortField: 'completed_at',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down',
          callback: this.formatDate
        },
        {
          name: 'remarks',
          title: 'Remarks',
          titleClass: 'hidden-lg-and-down',
          dataClass: 'hidden-lg-and-down'
        }
      ]
    }
  }
}
</script>
